console.log("🚫 Amai off DK");

// 🔹 Блокировка fetch-запросов Amai
(function() {
    var originalFetch = window.fetch;
    window.fetch = function(url, options) {
        if (url.includes("amai") || url.includes("pricing-by-quantity") || url.includes("common.js")) {
            console.warn("🚫 Fetch-запрос заблокирован:", url);
            return new Promise((resolve, reject) => reject("Amai is blocked"));
        }
        return originalFetch.apply(this, arguments);
    };
})();

// 🔹 Блокировка загрузки скриптов Amai через <script>
(function() {
    var originalScript = document.createElement;
    document.createElement = function(tagName) {
        if (tagName.toLowerCase() === "script") {
            var script = originalScript.apply(this, arguments);
            Object.defineProperty(script, 'src', {
                set: function(value) {
                    if (value.includes("amai") || value.includes("pricing-by-quantity") || value.includes("common.js")) {
                        console.warn("🚫 Скрипт Amai заблокирован:", value);
                        return;
                    }
                    script.setAttribute('src', value);
                }
            });
            return script;
        }
        return originalScript.apply(this, arguments);
    };
})();

// 🔹 Блокировка XMLHttpRequest для Amai
(function() {
    const originalXHR = window.XMLHttpRequest.prototype.open;
    window.XMLHttpRequest.prototype.open = function(method, url) {
        if (url.includes("amai") || url.includes("pricing-by-quantity") || url.includes("common.js")) {
            console.warn("🚫 XMLHttpRequest-запрос заблокирован:", url);
            return;
        }
        return originalXHR.apply(this, arguments);
    };
})();

// 🔹 Удаление Spurit, если он уже загружен
(function() {
    if (window.Spurit) {
        delete window.Spurit.QuantityBreaks2;
        delete window.Spurit;
    }
})();

// 🔹 Запрещаем повторное создание Spurit
Object.defineProperty(window, "Spurit", {
    get: function() {
        console.warn("🚫 Доступ к Spurit заблокирован.");
        return {};
    },
    set: function() {
        console.warn("🚫 Попытка установить Spurit заблокирована.");
    }
});

// 🔹 Блокировка через Proxy (на случай, если Shopify создаст его через eval)
window.Spurit = new Proxy({}, {
    get(target, prop) {
        console.warn(`🚫 Доступ к Spurit.${prop} заблокирован.`);
        return undefined;
    },
    set(target, prop, value) {
        console.warn(`🚫 Попытка установить Spurit.${prop} заблокирована.`);
        return false;
    }
});

// 🔹 Автоматическое удаление загружаемых Amai-скриптов
const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
            if (node.tagName === "SCRIPT" && node.src && (node.src.includes("amai") || node.src.includes("pricing-by-quantity") || node.src.includes("common.js"))) {
                console.warn("🚫 Удален запрещенный скрипт:", node.src);
                node.remove();
            }
        });
    });
});
observer.observe(document.documentElement, { childList: true, subtree: true });

console.log("✅ Amai полностью заблокирован.");
